import { getZonedDate } from '@eika-infrastruktur/date';
import { PaymentActionType } from './actions';
import { paymentInitialState } from './state';
const reducer = (state, action) => {
    switch (action.type) {
        case PaymentActionType.FROM_ACCOUNT_SELECTED:
            return {
                ...state,
                fromAccount: action.payload,
            };
        case PaymentActionType.TO_ACCOUNT_SELECTED:
            return {
                ...state,
                toAccount: action.payload,
            };
        case PaymentActionType.AMOUNT:
            return {
                ...state,
                amount: action.payload,
            };
        case PaymentActionType.NOTE:
            return {
                ...state,
                note: action.payload,
            };
        case PaymentActionType.OWNTEXT:
            return {
                ...state,
                ownText: action.payload,
            };
        case PaymentActionType.SET_KID:
            return {
                ...state,
                kid: action.payload,
            };
        case PaymentActionType.PAYMENT_DATE:
            return {
                ...state,
                paymentDate: action.payload,
            };
        case PaymentActionType.FIRST_BANKING_DATE_FROM_TODAY:
            return {
                ...state,
                firstBankingDateFromToday: action.payload,
            };
        case PaymentActionType.RESET:
            return {
                ...paymentInitialState,
            };
        case PaymentActionType.RESET_WITH_FROM_ACCOUNT:
            return {
                ...paymentInitialState,
                fromAccount: action.payload,
                paymentDate: getZonedDate(),
            };
        case PaymentActionType.SHOW_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: true,
            };
        case PaymentActionType.HIDE_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: false,
            };
        case PaymentActionType.SET_RECEIPT_TYPE:
            return {
                ...state,
                receiptType: action.payload,
            };
        case PaymentActionType.SET_IMMEDIATE:
            return {
                ...state,
                immediate: action.payload,
            };
        case PaymentActionType.ACCEPT_DUPLICATE:
            return {
                ...state,
                acceptDuplicate: action.payload,
            };
        case PaymentActionType.RESET_KID_AND_NOTE:
            return {
                ...state,
                kid: undefined,
                note: '',
            };
        case PaymentActionType.SET_INITIAL_KID_AND_NOTE:
            return {
                ...state,
                kid: action.payload.kid,
                note: action.payload.note ?? '',
                hasInitialKid: !!action.payload.kid?.value,
            };
        default:
            return state;
    }
};
const paymentReducer = (state, action) => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cPayment form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};
export default paymentReducer;
//# sourceMappingURL=data:application/json;base64,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